import { styled } from "@mui/material";
import { Avatar } from "../../../../../../components";

export const DeskItemAvatar = styled(Avatar)({
  width: 32,
  height: 32,
  border: "1px solid white",
});
